import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { RadioButton, RadioButtonGroup, FormLabel, Tooltip} from 'carbon-components-react';

const FormRadio = ({ options, label, name, itemValueField, itemTextField, itemDisabledField, onChange, tooltipText, reset,onReset, disabled}) => {
    const {register, formState, watch, setValue, trigger} = useFormContext(); 
    const [objValue, setObjValue] = useState(null);
    const watcher = watch(name);
    itemValueField = itemValueField ?? "id";
    itemTextField = itemTextField ?? "name";

    let obj = formState.errors[name];

    const array = name.substr(0, name.indexOf("["));

    const refreshObj = () => {
        if(array.length > 0){
            const optionalName = name.replace('.', '?.');
            obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
        }
    }

    useEffect(() => {
        if(!watcher)
            setObjValue(null);
        else
            setObjValue(watcher);
        
        refreshObj();

    }, [watcher]);
 
    useEffect(() => {
        if(!onReset){
        setObjValue(null);
        setValue(name, null);
        }
        refreshObj();

    }, [reset]);

    const change = (e) => {
        //console.log(e);
        if(onChange)
            onChange(e);
        if(e)
            setValue(name, e);
            
        trigger(name);
     
    }
    
    return(
        <div className="mb-6">
            <FormLabel>
                {
                tooltipText ? 
                <Tooltip triggerText={label}>
                    {tooltipText}
                </Tooltip>
                : <>{label}</>
                }
            </FormLabel>
            <RadioButtonGroup disabled={disabled} legendText=""  id={`rad-${name}`} {...register(name)} valueSelected={objValue} onChange={change} orientation="vertical"  invalidText={obj?.message}  invalid={!!obj} 
 >
                {options.map((item, idx) => {
                    //console.log("Disabled?", item);
                    return( <RadioButton key={idx} labelText={item[itemTextField]} value={item[itemValueField]} id={`rad-${name}-${item.id}`} disabled={item[itemDisabledField]} /> )
                })} 
            </RadioButtonGroup>
            {!!obj ? <div className='text-danger my-2'>{obj?.message}</div> :<></>}
                
        </div>
    )
}
export default FormRadio;